import * as React from 'react';

import { isExperimentEnabled } from '@reverbdotcom/commons/dist/user_context_helpers';
import { useUser } from '@reverbdotcom/commons/dist/user_hooks';

import { experiments } from '../shared/constants';
import FreeShippingProgressBar, { IFreeShippingStatus } from './free_shipping_progress_bar';

export interface IProps {
  statuses: IFreeShippingStatus[];
}

export function FreeShippingProgressBarContainer({ statuses }: IProps) {
  function ProgressBars() {
    return (
      <>
        {statuses.map((status, idx) => (
          <FreeShippingProgressBar
            key={idx}
            thresholdMet={status.thresholdMet}
            percentProgress={status.percentProgress}
            amountRemainingDisplay={status.amountRemainingDisplay}
            shopName={status.shopName}
            shopSlug={status.shopSlug}
            isBottomRow={idx === statuses.length - 1}
          />
        ))}
      </>
    );
  }

  const user = useUser();

  if (!statuses.length) { return null; }

  if (isExperimentEnabled(user, experiments.BUYER_FREE_SHIPPING_THRESHOLD)) {
    return (
      <div className="scaling-mtb-3">
        <section className="site-module">
          <div className="site-module__content">
            {ProgressBars()}
          </div>
        </section>
      </div>
    );
  }

  // Each FreeShippingProgressBar handles its own event tracking. If the experiment is inactive, we still
  // trigger renders for each (all of which will be empty/null renders) so that qualifying events are logged.
  return ProgressBars();
}

export default FreeShippingProgressBarContainer;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/cart/free_shipping_progress_bar_container.tsx